import {
  GET_TASKLIST,
  GET_TASKLIST_SUCCESS,
  GET_TASKLIST_FAIL,
  DELETE_TASKLIST,
  DELETE_TASKLIST_SUCCESS,
  DELETE_TASKLIST_FAIL,
  UPDATE_TASKLIST,
  UPDATE_TASKLIST_SUCCESS,
  UPDATE_TASKLIST_FAIL,
  ADD_NEW_TASKLIST,
  ADD_TASKLIST_SUCCESS,
  ADD_TASKLIST_FAIL,
  TASKLIST_LOADING,
  TASKLIST_RESET,
} from "./actionType";

export const resetTaskListState = (actionType) => ({
  type: TASKLIST_RESET,
  payload: { actionType },
});

export const getTaskListSuccess = (actionType, data) => ({
  type: GET_TASKLIST_SUCCESS,
  payload: { actionType, data },
});

export const getTaskListFail = (actionType, error) => ({
  type: GET_TASKLIST_FAIL,
  payload: { actionType, error },
});

export const getTaskList = data => ({
  type: GET_TASKLIST,
  payload: data,
});

export const getTaskListLoading = () => ({
  type: TASKLIST_LOADING
});

export const deleteTaskList = data => ({
  type: DELETE_TASKLIST,
  payload: data,
});

export const deleteTaskListSuccess = data => ({
  type: DELETE_TASKLIST_SUCCESS,
  payload: data,
});

export const deleteTaskListFail = error => ({
  type: DELETE_TASKLIST_FAIL,
  payload: error,
});

export const updateTaskList = data => ({
  type: UPDATE_TASKLIST,
  payload: data,
});

export const updateTaskListFail = error => ({
  type: UPDATE_TASKLIST_FAIL,
  payload: error,
});

export const updateTaskListSuccess = data => ({
  type: UPDATE_TASKLIST_SUCCESS,
  payload: data,
});

export const addNewTaskList = data => ({
  type: ADD_NEW_TASKLIST,
  payload: data,
});

export const addTaskListSuccess = data => ({
  type: ADD_TASKLIST_SUCCESS,
  payload: data,
});

export const addTaskListFail = error => ({
  type: ADD_TASKLIST_FAIL,
  payload: error,
});